import { Injectable } from '@angular/core';

export const TERM_INSURANCE_CONSTRAINTS = {
  annualIncome:       { min: 100_000,  max: 100_000_000, step: 10_000 },
  replacementYears:   { min: 1,        max: 40,          step: 1      },
  outstandingLoans:   { min: 0,        max: 100_000_000, step: 10_000 },
  futureGoals:        { min: 0,        max: 100_000_000, step: 10_000 },
  existingCover:       { min: 0,        max: 100_000_000, step: 10_000 },
  existingSavings:     { min: 0,        max: 100_000_000, step: 10_000 }
} as const;

export interface TermInsuranceResult {
  incomeReplacement: number;
  grossNeed: number;
  existingCoverAndSavings: number;
  recommendedCover: number;
  ruleOfThumbCover: number;
}

@Injectable({ providedIn: 'root' })
export class TermInsuranceCalculatorService {

  calculate(
    annualIncome: number,
    replacementYears: number,
    outstandingLoans: number,
    futureGoals: number,
    existingCover: number,
    existingSavings: number
  ): TermInsuranceResult {
    const incomeReplacement = annualIncome * replacementYears;
    const grossNeed = incomeReplacement + outstandingLoans + futureGoals;
    const existingCoverAndSavings = existingCover + existingSavings;
    const recommendedCover = Math.max(0, grossNeed - existingCoverAndSavings);
    const ruleOfThumbCover = annualIncome * 15;

    return { incomeReplacement, grossNeed, existingCoverAndSavings, recommendedCover, ruleOfThumbCover };
  }
}
